import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { HttpService, Logger, LoggerDecorated, LoggerDecorator } from 'vas-mobile-api';

@Injectable()
@LoggerDecorator()
export class DataExchangeService implements LoggerDecorated {
  logger: Logger;
  constructor(private http: HttpService, private router: Router) {

  }
  // Observable string sources
  private titleBarName = new Subject<string>();
  private filterToggle = new Subject<void>();
  private refresh = new Subject<void>();
  private back = new Subject<void>();
  private viewMode = new BehaviorSubject<string>('ltr');
  private loadingIndicator = new Subject<boolean>();
  private secretSubject = new BehaviorSubject<boolean>(false);
  private minLitre = new BehaviorSubject<number>(10000);
  private maxLitre = new BehaviorSubject<number>(50000);
  private orderInfo = new BehaviorSubject<boolean>(false);

  // Observable string streams
  public titelBarNameChange$ = this.titleBarName.asObservable();
  public filterToggle$ = this.filterToggle.asObservable();
  public refresh$ = this.refresh.asObservable();
  public back$ = this.back.asObservable();
  public viewModeChange$ = this.viewMode.asObservable();
  public loadingIndicator$ = this.loadingIndicator.asObservable();
  public maxLitre$ = this.minLitre.asObservable();
  public minLitre$ = this.maxLitre.asObservable();
  public orderInfo$ = this.orderInfo.asObservable();
  // Service message commands

  public fetchSystemParam() {
    this.http.getSystemParam('SSC-MIN_LITRES', false).subscribe((minLiteres) => {
      this.minLitre.next(minLiteres.data.value);
    }, () => {
      this.minLitre.next(10000);
    });

    this.http.getSystemParam('SSC-MAX_LITRES', false).subscribe((maxLiteres) => {
      this.maxLitre.next(maxLiteres.data.value);
    }, () => {
      this.maxLitre.next(50000);
    });

    this.http.getSystemParam('SCC-BESTIONO1_PROD', false).subscribe((orderInfo) => {
      if (typeof orderInfo.data.value === 'boolean') {
        this.orderInfo.next(orderInfo.data.value);
      } else {
        this.orderInfo.next(false);
      }

    }, () => {
      this.orderInfo.next(false);
    });

  }

  changeTitelBarName(titel: string) {
    this.titleBarName.next(titel);
  }

  getMinLitre(): number {
    return this.minLitre.getValue();
  }

  getMaxLitre(): number {
    return this.maxLitre.getValue();
  }

  getOrderInfo(): boolean {
    return this.orderInfo.getValue();
  }

  toggleFilter() {
    this.filterToggle.next();
  }

  triggerRefresh() {
    this.refresh.next();
  }

  triggerBack() {
    this.back.next();
  }

  changeViewMode(mode: string) {
    this.viewMode.next(mode);
    this.logger.debug('changing view mode:', mode);
  }

  showLoadingIndicator(visible: boolean) {
    this.loadingIndicator.next(visible);
  }

  getCurrentViewMode(): string {
    return this.viewMode.value;
  }

  isSecretEntered(): boolean {
    return this.secretSubject.value;
  }

  activateSecret() {
    this.secretSubject.next(true);
    this.router.navigate(['secret']);
  }

}
